import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog } from "@activecollab/components";
import { Field, Form, Formik } from "formik";
import PropTypes from "prop-types";
import { InputWithSelectedText } from "../Inputs/InputWithSelectedText";

export const RenameDialog = ({
  open,
  onSubmit,
  onCancel,
  title,
  name,
  submitBtnText,
  cancelBtnText,
  validationSchema,
  placeholder,
  maxLength,
  includeDirtyState,
  requiredName,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
    >
      <Formik
        initialValues={{ name }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        validateOnMount
      >
        {({ isValid, isSubmitting, touched, dirty }) => (
          <Form>
            <Dialog.Title>{title}</Dialog.Title>
            <Dialog.ContentDivider />
            <Dialog.Content>
              <Field name="name">
                {({ field }) => (
                  <InputWithSelectedText
                    size="big"
                    type="text"
                    data-testid="rename-dialog-name"
                    required={requiredName}
                    id="name"
                    placeholder={placeholder ?? t("Name")}
                    {...field}
                    className="tw-w-full"
                    maxLength={maxLength}
                    autoFocus
                    invalid={!isValid && touched}
                  />
                )}
              </Field>
            </Dialog.Content>
            <Dialog.ContentDivider />
            <Dialog.Actions>
              <Button
                type="submit"
                variant="primary"
                data-testid="rename-dialog-submit"
                data-qa-id="confirm-modal-submit"
                disabled={!isValid || isSubmitting || (!includeDirtyState && !dirty)}
                className="tw-mr-3"
              >
                {submitBtnText ?? t("Save")}
              </Button>
              <Button
                type="button"
                variant="secondary"
                onClick={onCancel}
              >
                {cancelBtnText ?? t("Cancel")}
              </Button>
            </Dialog.Actions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

RenameDialog.propTypes = {
  open: PropTypes.bool,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  title: PropTypes.string.isRequired,
  submitBtnText: PropTypes.string,
  cancelBtnText: PropTypes.string,
  name: PropTypes.string,
  validationSchema: PropTypes.object,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  includeDirtyState: PropTypes.bool,
  requiredName: PropTypes.bool,
};

RenameDialog.defaultProps = {
  open: false,
  name: "",
  maxLength: 191,
  includeDirtyState: false,
  requiredName: true,
};
